import * as React from 'react';
import { createUseStyles } from 'react-jss';

import { MinusIcon, PlusIcon } from '../Icons';
import { useIntl } from '../../providers';

interface MoreInformationButtonProps {
    onClick: () => void;
    collapsed?: boolean;
}

const useStyles = createUseStyles({
    moreInformationButton: {
        color: 'var(--secondary-color)',
        position: 'relative',
        userSelect: 'none',
        background: 'none',
        border: 'none',
        appearance: 'none',
        cursor: 'pointer',
        '&::after': {
            display: 'inline-block',
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            backgroundColor: 'var(--secondary-color)',
            height: '2px',
            width: '10px',
            visibility: 'hidden',
            transition: 'all 0.2s cubic-bezier(0.5, 0, 0.5, 1)',
        },
        '&:hover': {
            textDecoration: 'none',
            '&::after': {
                visibility: 'visible',
                width: '100%',
            },
        },
    },
});

const MoreInformationButton: React.FC<MoreInformationButtonProps> = ({
    onClick,
    collapsed = true,
}: MoreInformationButtonProps) => {
    const classes = useStyles();
    const { translate } = useIntl();

    return (
        <button onClick={onClick} className={classes.moreInformationButton}>
            {collapsed ? (
                <>
                    <PlusIcon stroke="var(--secondary-color)" /> {translate('productCard.action.moreInformation', 'more information')}
                </>
            ) : (
                <>
                    <MinusIcon stroke="var(--secondary-color)" /> {translate('productCard.action.showLess', 'show less')}
                </>
            )}
        </button>
    );
};

export default React.memo(MoreInformationButton);
